module.exports = __webpack_public_path__ + "static/post4-a5d2dbb41e4c95226f720ad233c0cd05.png";